"use client";

import dynamic from "next/dynamic";

const ModeToggle = dynamic(() => import("@/components/mode-toggle").then(mod => ({ default: mod.ModeToggle })), {
  ssr: false,
});

export default function ClientModeToggle() {
  return <ModeToggle />;
}
